import React from 'react'
import { COLORS } from '@btime/constants'
import { isEmpty } from 'ramda'
import { useAlert } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import FlexGrid from '../../../../../../../components/structure/FlexGrid'
import Button from '../../../../../../../components/actions/Button'
import { useChecklistFormActions } from '../../../../_form/ChecklistFormHandler'
import { useTriggers } from '../_load/TriggersLoader'

const ModalFooter = ({ isCategory, index }) => {
  const { t } = useTranslation('editChecklist')
  const { removeSelectedQuestion, removeCategory, closeTriggersQuestionCheckModal, closeTriggersCategoryCheckModal } =
    useChecklistFormActions()
  const triggers = useTriggers()
  const modal = useAlert()

  const handleRemove = () => {
    if (isCategory) {
      removeCategory(index)
      closeTriggersCategoryCheckModal()
    } else {
      removeSelectedQuestion()
      closeTriggersQuestionCheckModal()
    }
  }

  if (isEmpty(triggers)) {
    if (isCategory) {
      const shouldRemove = modal.confirm({
        title: t('removeModal.removeCategoryWarning')
      })
      if (shouldRemove) {
        removeCategory(index)
      }
      closeTriggersCategoryCheckModal()
    } else {
      closeTriggersQuestionCheckModal()
      removeSelectedQuestion()
    }
  }

  return (
    <FlexGrid justify="space-between" gutter={0.3}>
      <div />
      <Button color={COLORS.red} onClick={handleRemove}>
        {t('remove')}
      </Button>
    </FlexGrid>
  )
}

export default ModalFooter
